import { render, staticRenderFns } from "./FormInputItem.vue?vue&type=template&id=47a4b640&scoped=true&"
import script from "./FormInputItem.vue?vue&type=script&lang=js&"
export * from "./FormInputItem.vue?vue&type=script&lang=js&"
import style0 from "./FormInputItem.vue?vue&type=style&index=0&id=47a4b640&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a4b640",
  null
  
)

export default component.exports